import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { siteConfig } from '../data';
import { Menu, X, Phone, Mail } from 'lucide-react';

export default function Navbar() {
  const [isOpen, setIsOpen] = React.useState(false);
  const location = useLocation();

  return (
    <>
      {/* Topbar - Scrolls away */}
      <div className="bg-[#9abc5a] text-white py-2 z-50 relative">
        <div className="max-w-5xl mx-auto px-6 flex justify-between items-center text-xs md:text-sm">
          <div className="hidden md:block text-white">
            {siteConfig.contact.address}
          </div>
          <div className="flex items-center gap-6 ml-auto md:ml-0">
            <a href={`tel:${siteConfig.contact.phone}`} className="flex items-center gap-2 hover:text-white/80 transition-colors">
              <Phone size={14} />
              <span className="hidden sm:inline">{siteConfig.contact.phone}</span>
            </a>
            <a href={`mailto:${siteConfig.contact.email}`} className="flex items-center gap-2 hover:text-white/80 transition-colors">
              <Mail size={14} />
              <span className="hidden sm:inline">{siteConfig.contact.email}</span>
            </a>
          </div>
        </div>
      </div>

      {/* Main Navigation - Sticky */}
      <nav className="sticky top-0 left-0 right-0 z-50 bg-white border-b border-slate-100">
        <div className="max-w-5xl mx-auto px-6 py-4 flex flex-col md:flex-row md:items-center md:justify-between gap-4 md:gap-0">
          <div className="flex items-center justify-between w-full md:w-auto">
            <Link to="/" className="flex items-center gap-3 text-base md:text-lg font-serif tracking-tight text-slate-900">
              <img src={siteConfig.logo} alt="" className="w-12 h-12 object-contain" />
              {siteConfig.name}
            </Link>

            {/* Mobile Toggle */}
            <button
              className="md:hidden p-2 text-slate-400"
              onClick={() => setIsOpen(!isOpen)}
            >
              {isOpen ? <X size={20} /> : <Menu size={20} />}
            </button>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-12">
            {siteConfig.navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`text-sm transition-colors ${
                  location.pathname === item.href
                    ? 'text-slate-900 font-medium'
                    : 'text-slate-900 hover:opacity-70'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </div>
        </div>

        {/* Mobile Navigation Sidebar */}
        <div 
          className={`fixed inset-0 z-50 md:hidden transition-opacity duration-300 ${
            isOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
          }`}
        >
          {/* Backdrop */}
          <div 
            className="absolute inset-0 bg-slate-900/20 backdrop-blur-sm"
            onClick={() => setIsOpen(false)}
          />
          
          {/* Sidebar Panel */}
          <div 
            className={`absolute top-0 right-0 bottom-0 w-64 bg-white shadow-2xl transition-transform duration-300 ease-in-out transform ${
              isOpen ? 'translate-x-0' : 'translate-x-full'
            }`}
          >
            <div className="p-6 flex flex-col h-full">
              <div className="flex items-center justify-between mb-12">
                <span className="font-serif text-base text-slate-900">{siteConfig.name}</span>
                <button
                  className="p-2 -mr-2 text-slate-400 hover:text-slate-900 transition-colors"
                  onClick={() => setIsOpen(false)}
                >
                  <X size={24} />
                </button>
              </div>

              <nav className="flex flex-col gap-6">
                {siteConfig.navigation.map((item) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    className={`text-lg font-medium transition-colors ${
                      location.pathname === item.href
                        ? 'text-slate-900'
                        : 'text-slate-900 hover:opacity-70'
                    }`}
                    onClick={() => setIsOpen(false)}
                  >
                    {item.name}
                  </Link>
                ))}
              </nav>

              <div className="mt-auto pt-8 border-t border-slate-100">
                <p className="text-xs text-slate-400">
                  © {new Date().getFullYear()} {siteConfig.name}
                </p>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );

}
